import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {Icon } from "@amzn/meridian";
import homeTokens from "@amzn/meridian-tokens/base/icon/home";
import clockTokens from "@amzn/meridian-tokens/base/icon/clock";
import "./landing.scss";

export enum NavTab {
  HOME = "home",
  HISTORY = "history",
  HELP = "help",
  PROFILE = "profile",
}

const tabs: { id: NavTab; label: string; icon: object }[] = [
  { id: NavTab.HOME, label: "HOME", icon: homeTokens },
  { id: NavTab.HISTORY, label: "HISTORY", icon: clockTokens },
  /* {

    Temporarily disabled — Help and Profile tabs will be re-enabled once
    their designs are finalized and the corresponding actions are wired up.
    { id: NavTab.HELP, label: "HELP", icon: helpTokens },
    { id: NavTab.PROFILE, label: "PROFILE", icon: userTokens },

  } */

];

interface LandingFooterProps {
  active: NavTab;
  onTabChange: (tab: NavTab) => void;
  showHistory?: boolean;
}

const LandingFooter: React.FC<LandingFooterProps> = ({ active, onTabChange, showHistory = true }) => (
  <Row className="home-bottom-nav" alignmentHorizontal="center" spacingInset="400" spacing="500">
    {tabs
      .filter((tab) => tab.id !== NavTab.HISTORY || showHistory)
      .map((tab) => {
      const isActive = active === tab.id;
      return (

        <button onClick={() => onTabChange(tab.id)} className={isActive ? "home-nav-button-active" : "home-nav-button"}>
          <Column alignmentHorizontal="center" spacing="100" spacingInset="300">
            <Icon tokens={tab.icon} color="inverted" />
            <Text type="b100" color="inverted">
              {tab.label}
            </Text>
          </Column>
        </button>
      );
    })}
  </Row>
);

export default LandingFooter;
